import React, { useEffect, useState } from "react";
import { SelectAsyncOptionType } from "react-select/async";
import { SmSelectAsyncSearchBox } from "../../../controls/components/selectAsyncSearchBox/SelectAsyncSearchBox";
import { ListPartnerSearch, ListUserSearch } from "../../../../services/UserService";

export function AdminFilterUserControl(props: { filterStaffId?: number | string; doChangeStaffId?: (value: any) => void }) {
	const [selectedId, setSelectedId] = useState<string | number>(props.filterStaffId || "");
	useEffect(() => {
		setSelectedId(props.filterStaffId || "");
	}, [props.filterStaffId]);
	const loadStaffList = async (input: string, setOpts: (val: SelectAsyncOptionType[]) => void) => {
		try {
			const data = await ListUserSearch(input);
			const res = data;
			if (res) {
				const selectOpts = convertToSelectOptions(res);
				const filteredOptions = selectOpts.filter((option: any) =>
					option.label.toLowerCase().includes(input.toLowerCase())
				);
				const clearOption = { label: "Tất cả", value: "" };
				setOpts?.([clearOption, ...filteredOptions]);
				return [clearOption, ...filteredOptions];
			}
		} catch (err) {
			console.error(err);
		}

		setOpts([]);
		return;
	};

	return (
		<SmSelectAsyncSearchBox
			selectedId={selectedId}
			onChange={(value: any) => {
				setSelectedId(value);
				props.doChangeStaffId?.(value ? Number(value) : null);
			}}
			loadOptionPromise={loadStaffList}
		/>
	);
}

export function convertToSelectOptions(data: any) {
	let selectOptions = data.map((item: any) => ({
		value: item.id?.toString?.() || "",
		label: item.email,
		object: "",
	}));
	return selectOptions;
}
